'use client';

import { type FC } from 'react';
import styles from './BookmarkItem.module.css';
import type { BookmarkItemProps } from './BookmarkItem.types';
import { Flex } from '@/_components';

export const BookmarkItem: FC<BookmarkItemProps> = ({
  bookmark,
  index,
  onClick,
  setSelectedBookmark,
  selectedBookmark,
}) => {
  const goToPage = (pageIndex: number): void => {
    setSelectedBookmark(pageIndex);
    // Find the PDF container using data attribute
    const viewer = document.querySelector(
      '[data-testid="pdf-viewer-container"]',
    );
    if (!viewer) return;

    // Find the page by data attribute
    const pageElement = viewer.querySelector(
      `[data-page-number="${pageIndex}"]`,
    );

    if (!pageElement) {
      // If page not found, try to find by index (1-based)
      const pages = viewer.querySelectorAll('[data-page-number]');
      if (pages && pages.length >= pageIndex) {
        pages[pageIndex - 1]?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } else {
      pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Flex
      key={`${bookmark.title}-${index}`}
      isColumn={true}
      onClick={onClick}
      gap={2}
      xAlign="start"
      className={
        bookmark.items.length > 0
          ? styles.bookmarkItem
          : styles.bookmarkItemNoPadding
      }
    >
      <div
        onClick={(e) => {
          e.preventDefault();
          bookmark.pageIndex && goToPage(bookmark.pageIndex);
        }}
        className={styles.bookmarkLink}
        style={{ pointerEvents: bookmark.pageIndex ? 'auto' : 'none' }}
        data-selected={bookmark.pageIndex === selectedBookmark}
      >
        {bookmark.title}
      </div>
      {bookmark.items.length > 0 && (
        <Flex isColumn={true} gap={2}>
          {bookmark.items.map((bookmark, key) => {
            return (
              <BookmarkItem
                key={key}
                index={key}
                onClick={onClick}
                bookmark={bookmark}
                selectedBookmark={selectedBookmark}
                setSelectedBookmark={setSelectedBookmark}
              />
            );
          })}
        </Flex>
      )}
    </Flex>
  );
};
